const help = {
  'north, n': 'travel north',
  'east, e': 'travel east',
  'south, s': 'travel south',
  'west, w': 'travel west',
  'up, u': 'travel up',
  'down, d': 'travel down',
  'get <item>': 'get an item',
  'drop <item>': 'drop an item',
  'use <item>': 'use an item',
  'look, l': 'review the description of the room',
  'inventory, i, inv': 'list of items collected',
  'help': 'show this list of commands',
  'restart': 'reload the page',
  'credits': 'about us'
};

export { help as default };



/** WEBPACK FOOTER **
 ** ./src/lib/help.js
 **/